module.exports = __webpack_public_path__ + "img/grin-tongue-wink.a52bedac.svg";